import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import CircularProgress from '@mui/material/CircularProgress'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormHelperText from '@mui/material/FormHelperText'
import Grid from '@mui/material/Grid'
import Switch from '@mui/material/Switch'
import TextField from '@mui/material/TextField'
import Tooltip from '@mui/material/Tooltip'
import { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { useNavigate, useParams } from 'react-router-dom'
import { apiService } from '../../api/axiosClient'
import Page from '../../components/Page'
import { FileUploaderSingle } from '../../components/upload'
import DropzoneWrapper from '../../styles/react-dropzone'
import { convertURLtoFile } from '../../utils/convertURLtoFile'


const CategorySection = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [category, setCategory] = useState({})
    const [loading, setLoading] = useState(false)
    const [filessmall, setFilessmall] = useState([])
    const [fileslong, setFileslong] = useState([])
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm();

    useEffect(() => {
        const fetchData = async () => {
            const response = await apiService.get(`/category_section/${params.id}`)
            const payload = response.data;

            setCategory(payload.data)
        }

        fetchData().catch(e => console.error(e));
    }, [params.id]);

    useEffect(() => {
        reset({
            title: category.title,
            subtitle: category.subtitle,
            promotionUrl: category.promotionUrl,
            keywords: category.keywords,
            showme: category.showme
        })

        if(category.imageUrl1) convertURLtoFile(category.imageUrl1, setFilessmall)
        if(category.imageUrl2) convertURLtoFile(category.imageUrl2, setFileslong)

    }, [reset, category]);

    const goBack = () => {
        // createObjectURL를 통해 만들어진 url는 해당 브라우저가 존재한 상태에서 revokeObjectURL 메소드로 url을 무효화 시키지 않으면 
        // js 엔진에서 garbage collect를 시키지 않고 계속 변수가 남아 메모리 누수가 됩니다.
        // 그렇기 때문에 url 사용을 종료하면 revokeObjectURL 메소드를 사용하여 브라우저가 
        // 더이상 이 객체를 메모리에 들고 있지 않아도 된다고 알려야합니다.
        filessmall.map(file => (
            URL.revokeObjectURL(file)
        ))
        fileslong.map(file => (
            URL.revokeObjectURL(file)
        ))

        navigate(-1)
    }

    const onSubmit = async (data, e) => {
        setLoading(true)

        const [file1] = filessmall;
        const [file2] = fileslong;
        const formData = new FormData()

        formData.append('title', data.title);
        formData.append('subtitle', data.subtitle);
        formData.append('promotionUrl', data.promotionUrl);
        formData.append('showme', data.showme);
        formData.append('keywords', data.keywords);
        formData.append('file1', file1);
        formData.append('file2', file2);

        await apiService.postFormData(`/category_section/${category.id}`, formData)
        .then(response => {
            toast.success('수정 되었습니다')
            goBack()

        }).catch(error => {
            // 에러는 이제 axiosClient의 interceptor에서 자동으로 처리됩니다
            console.error('API Error:', error);
        }).finally(() => {
            setLoading(false)
        });
    }

    return (
        <Page title="Category Section">
            <Card>
                <form onSubmit={handleSubmit(onSubmit)} id="categoryform">
                    <CardContent sx={{ pt: 8 }}>
                        <Box sx={{ mb: 9, textAlign: 'center' }}>
                            <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                                카테고리
                            </Typography>
                        </Box>

                        <Grid container spacing={6}>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='title'
                                        control={control}
                                        rules={{ required: true }}
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='제목'
                                                id='title'
                                                onChange={onChange}
                                                placeholder='제목을 입력해주세요'
                                                error={Boolean(errors.title)}
                                                aria-describedby='validation-async-title'
                                                variant="standard"
                                            />
                                        )}
                                    />
                                    {errors.title && (
                                        <FormHelperText sx={{ color: 'error.main' }} id='validation-async-title'>
                                            필수
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='subtitle'
                                        control={control}
                                        rules={{ required: true }}
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='카테고리 메뉴 오른쪽 광고 내용'
                                                id='subtitle'
                                                onChange={onChange}
                                                placeholder='카테고리 메뉴 오른쪽 광고 내용을 입력해주세요'
                                                error={Boolean(errors.subtitle)}
                                                aria-describedby='validation-async-subtitle'
                                                variant="standard"
                                            />
                                        )}
                                    />
                                    {errors.subtitle && (
                                        <FormHelperText sx={{ color: 'error.main' }} id='validation-async-subtitle'>
                                            필수
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                <Controller
                                    name='promotionUrl'
                                    control={control}
                                    rules={{ required: false }}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                    <TextField
                                        value={value}
                                        label='promotionUrl'
                                        id='promotionUrl'
                                        onChange={onChange}
                                        placeholder='카테고리 메뉴 오른쪽 광고 프로모션 주소 URL을 입력해주세요'
                                        error={Boolean(errors.keywords)}
                                        aria-describedby='validation-async-promotionUrl'
                                        variant="standard"
                                    />
                                    )}
                                />
                                {errors.promotionUrl && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-promotionUrl'>
                                    필수
                                    </FormHelperText>
                                )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                <Controller
                                    name='keywords'
                                    control={control}
                                    rules={{ required: false }}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                    <TextField
                                        value={value}
                                        label='keywords'
                                        id='keywords'
                                        onChange={onChange}
                                        placeholder='업데이트 버튼을 통해 자동으로 입력됩니다.'
                                        variant="standard"
                                    />
                                    )}
                                />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <FormControl>
                                    <Controller
                                        name='showme'
                                        control={control}                                            
                                        defaultValue={false}
                                        render={({ field: { value, onChange } }) => (
                                            <FormControlLabel
                                                label='홈페이지 추천 카테고리 노출'
                                                control={
                                                    <Switch checked={value} onChange={onChange} name='controlled' />
                                                }
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Tooltip title="카테고리 메뉴에 보여지는 이미지 정의">   
                                    <Typography color='primary' sx={{ mb: 3, lineHeight: '2rem' }}>
                                        메뉴 및 추천광고용 
                                        <Box component="span" sx={{ ml: 1, fontSize: '0.8rem' }} >추전사이즈(300x300)</Box>
                                    </Typography>
                                </Tooltip>
                                
                                <DropzoneWrapper>
                                    <FileUploaderSingle files={filessmall} setFiles={setFilessmall} />
                                </DropzoneWrapper>
                            </Grid>
                            
                            <Grid item xs={12} md={6}>
                                <Tooltip title="카테고리 검색페이지 상단에 보여지는 이미지 정의">
                                    <Typography color='primary' sx={{ mb: 3, lineHeight: '2rem' }}>
                                        상품 검색페이지 배너 
                                        <Box component="span" sx={{ ml: 1, fontSize: '0.8rem' }} >추전사이즈(1900x200)</Box>
                                    </Typography>
                                </Tooltip>

                                <DropzoneWrapper>
                                    <FileUploaderSingle files={fileslong} setFiles={setFileslong} />
                                </DropzoneWrapper>
                            </Grid>
                        </Grid>
                    </CardContent>
                </form>

                <CardActions className='card-action'>
                    <Button type="submit" form="categoryform" variant='contained'>
                        {loading ? (
                            <CircularProgress
                                sx={{
                                    color: 'common.white',
                                    width: '20px !important',
                                    height: '20px !important',
                                    mr: theme => theme.spacing(2)
                                }}
                            />
                        ) : null}
                        수정
                    </Button>
                    <Button variant='outlined' color='secondary' onClick={goBack}>
                        취소
                    </Button>
                </CardActions>
            </Card>
        </Page>
    )
}

export default CategorySection